import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetAttEventState, getAttEvent as onGetAttEvents, addNewAttEvent as onAddNewAttEvent, updateAttEvent as onUpdateAttEvent, deleteAttEvent as onDeleteAttEvent, getAttEventLoading } from "../../../store/attEvent/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import { setBranchSelect, setCompanySelect } from "../../../store/actions";

const AttEvent = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clients, clientLoading, attEvents, isAttEventCreated, isAttEventSuccess, loading, error, companies, companyLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    attEvents: state.AttEvent.attEvents,
    isAttEventCreated: state.AttEvent.isAttEventCreated,
    isAttEventSuccess: state.AttEvent.isAttEventSuccess,
    loading: state.AttEvent.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    error: state.AttEvent.error,
  }));

  const [attEventList, setAttEventList] = useState([]);
  const [attEvent, setAttEvent] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [type, setType] = useState("");
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [approveModal, setApproveModal] = useState(false);
  const [companyName, setCompanyName] = useState({});

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const typeData = [
    {
      options: [
        { label: "Hari Libur", value: "Free Day" },
        { label: "Hari Pendek", value: "Short Day" },
      ],
    },
  ];
  const onClickDelete = (attEvent) => {
    setAttEvent(attEvent);
    setDeleteModal(true);
  };

  const handleDeleteAttEvent = () => {
    if (attEvent) {
      dispatch(onDeleteAttEvent(attEvent));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    setAttEventList(attEvents);
  }, [attEvents]);

  useEffect(() => {
    if (companySelected) {
      setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
      dispatch(resetAttEventState());
      dispatch(onGetAttEvents({ companyId: companySelected?.value ?? "" }));
    }
  }, [companySelected]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setAttEvent(null);
      setType("");
      validation.resetForm();
      validation.setErrors({});
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleAttEventClick = useCallback(
    (arg) => {
      const data = arg;
      setType(data.type);
      setAttEvent({
        id: data.id,
        description: data.description,
        eventat: data.eventat,
        clockoutat: data.clockoutat,
        name: data.name,

        company: data.attendance_event_company && {
          label: data.attendance_event_company ? data.attendance_event_company.name : "",
          value: data.attendance_event_company ? data.attendance_event_company.id : "",
        },
        client: data.attendance_event_client && {
          label: data.attendance_event_client ? data.attendance_event_client.name : "",
          value: data.attendance_event_client ? data.attendance_event_client.id : "",
        },
        type: { label: data.type, value: data.type },
      });

      setIsEdit(true);
      toggle();
    },
    [toggle, userType]
  );

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteAttEvent(element.value));
    });
    checkall.checked = false;
  };

  const onClickApprove = (employee) => {
    setAttEvent(employee);
    setApproveModal(true);
  };

  const handleApproveEmployee = () => {
    if (attEvent) {
      attEvent.setApprove = true;
      dispatch(onUpdateAttEvent(attEvent));
      dispatch(resetAttEventState());
      dispatch(onGetAttEvents());
      setApproveModal(false);
    }
  };

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input type="checkbox" className="dataCheckbox form-check-input me-2" value={data.id} />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateAttendanceEvent") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleAttEventClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteAttendanceEvent") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                  {data.typeId === 1 && (
                    <button
                      className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : userRole && userRole.split(",").indexOf("approveAttendanceEvent") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : "btn-label btn btn-sm btn-soft-success fs-12 me-1 d-none"}
                      onClick={() => {
                        data.actionTitle = `Anda akan menyetujui jadwal ${data.name} #${data.code}`;
                        onClickApprove(data);
                      }}
                    >
                      <i className="ri-checkbox-circle-line fs-15 label-icon align-middle me-1"></i>APPROVE
                    </button>
                  )}
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Event",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "Tipe",
        accessor: "type",
        filterable: true,
      },
      {
        Header: "Tanggal",
        accessor: "eventat",
        filterable: true,
        Cell: (rates) => <> {handleValidDate(rates.row.original.eventat)} </>,
      },
      {
        Header: "Jam Selesai",
        accessor: "clockoutat",
        filterable: true,
      },
      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [handleAttEventClick, userType, userRole]
  );

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(new Date(date), "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(new Date(time), "YYYY/MM/DD").format("HH:mm");
  };

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: attEventList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  function handleFilter() {
    let eventat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr[1]) {
      eventat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var name = type.value ? type.value : "";
    const param = {
      title: searchValue,
      eventat: eventat,
      endat: endat,
      name: name,
      companyId: companySelected?.value ?? "",
    };
    dispatch(onGetAttEvents(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setAttEventList([]);
    setType("");
    setSearchValue("");
    setGlobalFilter(undefined);
    dispatch(resetAttEventState());
    dispatch(onGetAttEvents({ companyId: companySelected?.value ?? "" }));
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      description: (attEvent && attEvent.description) ?? "",
      name: (attEvent && attEvent.name) ?? "",
      clockoutat: (attEvent && attEvent.clockoutat) ?? "",
      eventat: (attEvent && attEvent.eventat) ?? "",
      client: (attEvent && attEvent.client) || clientSelected,
      company: (attEvent && attEvent.company) || companySelected,
      type: (attEvent && attEvent.type) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Pick Event Name"),
      type: Yup.object().required("Please Enter Type"),
      client: Yup.object().required("Silahkan isi grup perusahaan"),
      company: Yup.object().required("Please Select Company"),
      eventat: Yup.string().required("Please Pick Event Date"),
    }),
    onSubmit: (values) => {
      dispatch(getAttEventLoading());
      if (isEdit) {
        const updateAttEvent = {
          id: attEvent ? attEvent.id : 0,
          type: values.type.value,
          description: values.description,
          name: values.name,
          clockoutat: values.clockoutat,
          eventat: values.eventat,
          rates: values.rates,
          clientId: values.client.value,
          companyId: values.company.value,
        };
        dispatch(onUpdateAttEvent(updateAttEvent));
        validation.resetForm();
      } else {
        const newAttEvent = {
          type: values.type.value,
          description: values.description,
          name: values.name,
          eventat: values.eventat,
          clockoutat: values.clockoutat,
          rates: values.rates,
          clientId: values.client.value,
          companyId: values.company.value,
        };
        dispatch(onAddNewAttEvent(newAttEvent));
        validation.resetForm();
      }
      toggle();
    },
  });

  document.title = "Hari Pendek & Libur | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={attEventList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteAttEvent} onCloseClick={() => setDeleteModal(false)} />
      <ApproveModal data={attEvent && attEvent.attEvent_employee ? attEvent.attEvent_employee.name + " - " + attEvent.rates : ""} show={approveModal} onApproveClick={handleApproveEmployee} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Opsi Penggajian" pageTitle="Hari Pendek & Libur" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createAttendanceEvent") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-user-unfollow-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <button type="button" className="btn btn-success me-1" onClick={() => setIsExportCSV(true)}>
              <i className="ri-file-download-line me-1 align-bottom fs-14"></i> Export
            </button>
            {/* <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-soft-danger" : userRole && userRole.split(",").indexOf("deleteAttendanceEvent") !== -1 ? "btn btn-soft-danger" : "btn btn-soft-danger d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Hapus
            </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card id="attEventList">
              <CardBody className="pt-0">
                <div>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={5}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                value={filterDate}
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Ubah Hari Pendek & Libur" : "Tambah Hari Pendek & Libur"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3">
                          <Label htmlFor="client-field" className="form-label">
                            Grup Usaha&nbsp;{" "}
                            {clientLoading && (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            )}
                          </Label>
                          <Select
                            name="client"
                            value={validation.values.client}
                            isDisabled={userType === "admin" || userType === "client" ? false : true}
                            placeholder="Pilih Grup Usaha"
                            onChange={(e) => {
                              validation.setFieldValue("client", e);
                            }}
                            options={clientList}
                          ></Select>
                        </div>

                        <div className="mb-3">
                          <Label htmlFor="company-field" className="form-label">
                            Perusahaan&nbsp;{" "}
                            {companyLoading && (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            )}
                          </Label>
                          <Select
                            name="company"
                            value={validation.values.company}
                            placeholder="Pilih Perusahaan"
                            isDisabled={userType === "admin" || userType === "client" ? false : true}
                            onChange={(e) => {
                              dispatch(setBranchSelect(null));
                              dispatch(setCompanySelect(e));
                              validation.setFieldValue("company", e);
                            }}
                            options={companyList}
                          ></Select>
                        </div>
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="type" className="form-label">
                            Type
                          </Label>
                          <Select
                            name="type"
                            value={validation.values.type}
                            placeholder="Pilih Type"
                            onChange={(e) => {
                              validation.setFieldValue("clockoutat", "");
                              validation.setFieldValue("type", e);
                              setType(e.value);
                            }}
                            options={typeData}
                            noOptionsMessage={(e) => "Type Employee to get option"}
                            invalid={validation.touched.type && validation.errors.type ? true : false}
                          ></Select>
                          {validation.touched.type && validation.errors.type ? (
                            <p className="text-danger" type="invalid">
                              {validation.errors.type}
                            </p>
                          ) : null}
                        </div>
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="date-field" className="form-label">
                            Tanggal Event
                          </Label>
                          <Flatpickr
                            name="eventat"
                            className="form-control"
                            placeholder="Pilih Tanggal"
                            options={{ enableTime: false, dateFormat: "Y/m/d" }}
                            value={validation.values.eventat ?? ""}
                            onChange={(o, e) => {
                              validation.setFieldValue("eventat", e);
                            }}
                          />
                          {validation.touched.eventat && validation.errors.eventat ? (
                            <p className="text-danger" type="invalid">
                              {validation.errors.eventat}
                            </p>
                          ) : null}
                        </div>
                        <div className={type === "Short Day" ? "mb-3 col-lg-9" : "mb-3 col-lg-12"}>
                          <Label htmlFor="name-field" className="form-label">
                            Nama Acara{" "}
                          </Label>
                          <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama Acara" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                          {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                        </div>
                        {type === "Short Day" ? (
                          <div className="mb-3 col-lg-3">
                            <Label htmlFor="clockoutat-field" className="form-label">
                              Jam Selesai
                            </Label>
                            <Flatpickr
                              className="form-control"
                              id="clockoutat-field"
                              name="clockoutat"
                              value={validation.values.clockoutat}
                              options={{
                                enableTime: true,
                                noCalendar: true,
                                dateFormat: "H:i",
                                time_24hr: true,
                              }}
                              onChange={(obj, str) => {
                                validation.setFieldValue("clockoutat", str);
                              }}
                            />
                            {validation.touched.clockoutat && validation.errors.clockoutat ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.clockoutat}
                              </small>
                            ) : null}
                          </div>
                        ) : (
                          <></>
                        )}
                        <div className="mb-4 col-lg-12">
                          <Label htmlFor="des-field" className="form-label">
                            Ketertangan
                          </Label>
                          <Input name="description" id="des-field" className="form-control" placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading ? (
                              <Spinner size="sm" className="flex-shrink-0" role="name">
                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AttEvent;
